import React from 'react';
import PropTypes from 'prop-types';
import s from './Sidebar.module.css';
import MenuBar from './MenuBar/MenuBar';

const Sidebar = (props) => {
  return (
    <aside className={s.sidebar}>
      <div className={'sidenav-outer ' + s.sidenavOuter}>
        <MenuBar
          partnerNumber={props.partnerNumber}
          role={props.role}
          permissions={props.permissions}
        />
      </div>
    </aside>
  );
};

Sidebar.propTypes = {
  partnerNumber: PropTypes.string,
  role: PropTypes.string,
  permissions: PropTypes.array,
};

export default Sidebar;
